import { ApplicationIcon } from "../../components/ApplicationIcon";

export function MemberPortalTabs({ activeTab, tabs = [] }) {
  if (tabs.length <= 1) {
    return null;
  }
  const active = tabs.find((tab) => tab.id === activeTab) || tabs[0];

  return (
    <>
      <div className="member-console-active-tab">
        <span>{active?.detail || "Member app"}</span>
        <strong>{active?.label || "Today"}</strong>
      </div>
      <nav className="member-console-tabs" aria-label="Member portal applications">
        {tabs.map((tab) => (
          <a
            aria-current={activeTab === tab.id ? "page" : undefined}
            className={activeTab === tab.id ? "is-active" : ""}
            href={tab.href}
            key={tab.id}
          >
            <ApplicationIcon appKey={tab.iconKey || tab.id} label={tab.icon || tab.label} />
            <span className="member-console-tab-copy">
              <strong>{tab.label}</strong>
              <span>{tab.detail}</span>
            </span>
          </a>
        ))}
      </nav>
    </>
  );
}

export function MemberPortalSectionTabs({ activeSection, onSelect, sections = [] }) {
  if (sections.length <= 1) {
    return null;
  }

  return (
    <div className="member-portal-section-tabs" role="tablist" aria-label="Application sections">
      {sections.map((section) => (
        <button
          aria-selected={activeSection === section.id}
          className={activeSection === section.id ? "is-active" : ""}
          key={section.id}
          onClick={() => onSelect(section.id)}
          role="tab"
          type="button"
        >
          <strong>{section.label}</strong>
          <span>{section.detail}</span>
        </button>
      ))}
    </div>
  );
}
